/**
 * useRangeSearchParams : plage d'analyse de la comparaison portée par l'URL
 * (routes /compare et /vet/compare). Paramètres align, range, from, to
 * (analysisRange.parseRangeParams) ; chaque choix remplace l'entrée
 * d'historique (replace: true) et conserve les autres paramètres (ids, horse).
 * Un lien partagé rouvre donc la même plage, dans le même mode d'axe.
 *
 * @returns {{ range: Object|null, onRangeChange: (selection: Object) => void }}
 */
import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { parseRangeParams, writeRangeParams } from './analysisRange';

const KEYS = ['align', 'range', 'from', 'to'];

export default function useRangeSearchParams() {
  const [params, setParams] = useSearchParams();
  // Clé brute : la sélection garde une identité stable tant que l'URL de plage
  // ne change pas (la page mémoïse son analyse dessus).
  const raw = KEYS.map(key => params.get(key) ?? '').join('\n');
  const range = useMemo(() => {
    const values = Object.fromEntries(raw.split('\n').map((v, i) => [KEYS[i], v || null]));
    return parseRangeParams(key => values[key] ?? null);
  }, [raw]);
  const onRangeChange = useCallback(
    (selection) => setParams(prev => writeRangeParams(prev, selection), { replace: true }),
    [setParams],
  );
  return { range, onRangeChange };
}
